export default __webpack_public_path__ + "static/media/settings-icon.488b839b.svg";